import api from '../utils/api/api.service';
import errorHelper from '../utils/api/error-helper.service';
import FinanceRequestMapper from '../../mappers/finance-request.mapper';
import {
  FinanceRequestDecisionPayload,
  FinanceRequestListQuery,
  FinanceRequestManagerModel,
  SaveFinanceRequestPayload
} from '../../models/finance-request.model';
import {
  FinanceRequestSaveResultUiModel,
  FinanceRequestUiModel
} from '../../ui-models/finance-request.ui-model';
import { ErrorInfo } from '../../interfaces/error-info.interface';

const MODULE_NAME = 'finance-request';

const fail = (response: unknown, fn: unknown) => {
  const res = response as {
    status?: number;
    data?: { errorCode?: string; message?: string };
    problem?: unknown;
  };
  const info = errorHelper(
    Number(res.status),
    res.data && res.data.errorCode ? String(res.data.errorCode || '') : String(res.problem || ''),
    MODULE_NAME,
    (fn as { displayName?: string }).displayName as string
  );
  return res.data && res.data.message ? { ...info, message: res.data.message } : info;
};

export function getFinanceRequests(
  query: FinanceRequestListQuery
): Promise<FinanceRequestUiModel[] | ErrorInfo> {
  return api.getFinanceRequests(query).then((response) => {
    if (response.ok && response.data && response.data.data) {
      return FinanceRequestMapper.mapToUIList(response.data.data);
    }
    return fail(response, api.getFinanceRequests);
  });
}

export function getFinanceRequest(id: string): Promise<FinanceRequestUiModel | ErrorInfo> {
  return api.getFinanceRequest(id).then((response) => {
    if (response.ok && response.data && response.data.data) {
      return FinanceRequestMapper.mapToUI(response.data.data);
    }
    return fail(response, api.getFinanceRequest);
  });
}

export function getMyFinanceManager(): Promise<FinanceRequestManagerModel | null | ErrorInfo> {
  return api.getMyFinanceManager().then((response) => {
    if (response.ok && response.data) return response.data.data || null;
    return fail(response, api.getMyFinanceManager);
  });
}

export function saveFinanceRequest(
  payload: SaveFinanceRequestPayload,
  id?: string
): Promise<FinanceRequestUiModel | ErrorInfo> {
  const request = id ? api.updateFinanceRequest(id, payload) : api.createFinanceRequest(payload);
  return request.then((response) => {
    if (response.ok && response.data && response.data.data) {
      return FinanceRequestMapper.mapToUI(response.data.data);
    }
    return fail(response, id ? api.updateFinanceRequest : api.createFinanceRequest);
  });
}

export function deleteFinanceRequest(id: string): Promise<boolean | ErrorInfo> {
  return api.deleteFinanceRequest(id).then((response) => {
    if (response.ok) return true;
    return fail(response, api.deleteFinanceRequest);
  });
}

export function submitFinanceRequest(
  id: string
): Promise<FinanceRequestSaveResultUiModel | ErrorInfo> {
  return api.submitFinanceRequest(id).then((response) => {
    if (response.ok && response.data && response.data.data) {
      return {
        request: FinanceRequestMapper.mapToUI(response.data.data),
        ticketWarning: response.data.ticketWarning
      };
    }
    return fail(response, api.submitFinanceRequest);
  });
}

export function decideFinanceRequest(
  id: string,
  payload: FinanceRequestDecisionPayload
): Promise<FinanceRequestSaveResultUiModel | ErrorInfo> {
  return api.decideFinanceRequest(id, payload).then((response) => {
    if (response.ok && response.data && response.data.data) {
      return {
        request: FinanceRequestMapper.mapToUI(response.data.data),
        ticketWarning: response.data.ticketWarning
      };
    }
    return fail(response, api.decideFinanceRequest);
  });
}
